import React from 'react'
import { Link } from 'react-router-dom'

export const GRNDaDLocations: React.FC = () => {
  return (
    <main
      className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16"
      data-testid="grndad-locations-container"
    >
      <div className="max-w-7xl mx-auto">
        {/* Sub-navigation */}
        <nav className="mb-8 border-b border-[#3C2416]/20 pb-4">
          <div className="flex flex-wrap gap-6">
            <Link
              to="/grndad/about"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              About
            </Link>
            <Link
              to="/grndad/locations"
              className="text-[#A6410A] font-medium border-b-2 border-[#A6410A] pb-1"
            >
              Locations
            </Link>
            <Link
              to="/grndad/executive-committee"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Executive Committee
            </Link>
            <Link
              to="/grndad/benefits-of-joining"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Benefits of Joining
            </Link>
            <Link
              to="/grndad/speaker-series"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Speaker Series
            </Link>
          </div>
        </nav>

        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-8">
          GRNDaD Locations
        </h1>

        <div className="space-y-8">
          {/* Interactive Map */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-8 pb-4">
              <h2 className="text-2xl font-semibold text-[#3C2416] mb-4">
                GRNDaD Participating Sites Map
              </h2>
              <p className="text-[#3C2416]/70 mb-6">
                Explore the locations of our participating research sites across
                the United States.
              </p>
            </div>
            <div className="h-[600px] w-full">
              <iframe
                src="https://www.google.com/maps/d/embed?mid=1xRNuXK1IwThEyCEp9V7f7ekc9e-yDLSU&amp;headers=false&amp;chrome=false"
                width="100%"
                height="100%"
                title="GRNDaD Locations Map"
                className="border-0"
                style={{ border: 0 }}
              ></iframe>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#3C2416] mb-6">
              Contact Information
            </h2>

            <div className="bg-[#FDF7F2] border-l-4 border-[#A6410A] p-6">
              <h3 className="text-lg font-semibold text-[#3C2416] mb-3">
                Want to Join as a Site?
              </h3>
              <p className="text-[#3C2416] mb-4">
                If you are a clinic that takes care of people living with sickle
                cell disease and would like to inquire about joining as a GRNDaD
                site, please contact us:
              </p>
              <a
                href="mailto:GRNDaDSCD@gmail.com"
                className="text-[#A6410A] font-medium hover:underline"
              >
                GRNDaDSCD@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
